import ReportRoutes from './routes'
export default ReportRoutes



// WEBPACK FOOTER //
// ./src/containers/reports/routes/index.js